import { UserDetailResponse } from 'api'
import api, { AxiosExceptUrl } from './api'

export const getUsers = (id, ...args: AxiosExceptUrl<typeof api.get>) => {
  return api.get<UserDetailResponse>(`/users/${id}`, ...args)
}

export const createUser = (...args: AxiosExceptUrl<typeof api.post>) => {
  return api.post<any>('/users', ...args)
}

export const updateUser = (id, ...args: AxiosExceptUrl<typeof api.put>) => {
  return api.put<any>(`/users/${id}`, ...args)
}

export const deactivateUser = (
  id,
  ...args: AxiosExceptUrl<typeof api.post>
) => {
  return api.post<any>(`/users/${id}/deactivate-user`, ...args)
}

export const activateUser = (id, ...args: AxiosExceptUrl<typeof api.post>) => {
  return api.post<any>(`/users/${id}/activate-user`, ...args)
}

export const deleteUser = (id, ...args: AxiosExceptUrl<typeof api.delete>) => {
  return api.delete<any>(`/users/${id}`, ...args)
}
